import { Component, inject, input, InputSignal } from '@angular/core';
import { UploadContentType } from '../../types/upload-content.type';
import { IconComponent } from "@kinomap-dev/ng-ui-lib/basics";
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { ColorService } from '../../services/color.service';
import { CountryService } from '../../services/country.service';
import { IconType } from '@kinomap-dev/ng-ui-lib/core';
import { contentTypeToIcon } from '../../utils/content-type-to-icon';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';

@Component({
  selector: 'app-content-list-light-element',
  imports: [IconComponent, TranslateModule, DatePipe, UpperFirstLetterPipe],
  templateUrl: './content-list-light-element.html',
  styleUrl: './content-list-light-element.scss',
})
export class ContentListLightElement {
  colorService: ColorService = inject(ColorService);
  countryService: CountryService = inject(CountryService);

  content: InputSignal<UploadContentType> = input.required();

  get icon(): IconType {
    return contentTypeToIcon(this.content().content_type)
  }

}
